(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4009],{

/***/ 22316:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smes",
      function () {
        return __webpack_require__(84736);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.esm.js
var disclosure_esm = __webpack_require__(21228);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(35131);
// EXTERNAL MODULE: ./pages/smes/style.module.css
var style_module = __webpack_require__(99733);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/UI/button/button.js
var button_button = __webpack_require__(88944);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react.useState(null);
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map

// EXTERNAL MODULE: ./node_modules/@react-hook/media-query/dist/module/index.js
var dist_module = __webpack_require__(84990);
// EXTERNAL MODULE: ./helpers/constant/content_data.js
var content_data = __webpack_require__(53597);
// EXTERNAL MODULE: ./helpers/utility/class_name.js
var class_name = __webpack_require__(98078);
;// CONCATENATED MODULE: ./pages/smes/index.js













function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Smes(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), isVisibleCTA = ref[0], setIsVisibleCTA = ref[1];
    var ref1 = useInView({
        threshold: 0
    }), ref2 = ref1.ref, inView = ref1.inView, entry = ref1.entry;
    var mobile = (0,dist_module/* useMediaQueries */.l)({
        screen: "screen",
        min: "(min-width: 0px)",
        max: "(max-width: 1023px)"
    });
    var monitor = (0,dist_module/* useMediaQueries */.l)({
        screen: "screen",
        min: "(min-width: 1024px)"
    });
    // Todo extract ease to components
    var easeIcons = [
        {
            id: 1,
            imageUrl: "/assets/icon-svg/overall-ease.svg",
            title: "แผนประกันภัยที่ครอบคลุมทุกความต้องการ"
        },
        {
            id: 2,
            imageUrl: "/assets/icon-svg/installment.svg",
            title: "ผ่อนได้ จ่ายสะดวกได้หลายช่องทาง"
        },
        {
            id: 3,
            imageUrl: "/assets/icon-svg/all-time.svg",
            title: "ปรึกษาฟรี! 24 ชั่วโมง"
        },
        {
            id: 4,
            imageUrl: "/assets/icon-svg/easy-claim.svg",
            title: "เคลมสะดวก ดูแลทุกผลประโยชน์ของคุณ"
        }, 
    ];
    (0,react.useEffect)(function() {
        document.querySelector('main').classList.add('w-overflow');
    }, []);
    (0,react.useEffect)(function() {
        if (inView) {
            setIsVisibleCTA(true);
        } else {
            setIsVisibleCTA(false);
        }
    }, [
        inView
    ]);
    var onClickHandler = function() {
        router.push('/smes/form/');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react_production_min.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "ประกันภัยธุรกิจ SME กับ TQM Home"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).sme_page_container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (style_module_default()).page_splash,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (style_module_default()).page_splash_bg,
                            children: [
                                mobile.matchesAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/assets/images/sme-bg-mobile.png",
                                    height: "380",
                                    width: "360",
                                    objectFit: "contain",
                                    layout: "responsive"
                                }),
                                monitor.matchesAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/assets/images/sme-bg-desktop.png",
                                    height: "402",
                                    width: "1140",
                                    objectFit: "contain",
                                    layout: "responsive"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (style_module_default()).sme_details,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).page_splash_content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (style_module_default()).title_mobile,
                                        children: "ประกันภัยธุรกิจ SME กับ TQM Home"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (style_module_default()).title_notebook,
                                        children: "ประกันภัยธุรกิจรายย่อย (SME)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "ประกันภัยคุ้มครองธุรกิจของคุณ ภัยธรรมชาติ ไฟฟ้าลัดวงจร โจรกรรม น้ำท่วม การสูญเสียรายได้ เพื่อให้ธุรกิจสามารถดำเนินต่อได้ไม่สะดุด แม้เกิดเหตุไม่คาดคิด"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (style_module_default()).ease_items,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (style_module_default()).ease_items_container,
                                            children: easeIcons.map(function(ease) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                    className: (style_module_default()).ease_item,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).ease_icon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                src: ease.imageUrl,
                                                                layout: "fill",
                                                                objectFit: "contain"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: ease.title
                                                        })
                                                    ]
                                                }, ease.id);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (style_module_default()).button_wrapper,
                                        ref: ref2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                                            color: "blue",
                                            text: "สนใจทำประกัน",
                                            onClick: onClickHandler
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure_esm/* Disclosure */.p, {
                                defaultOpen: true,
                                children: function(param) {
                                    var open = param.open;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react_production_min.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure_esm/* Disclosure.Button */.p.Button, {
                                                className: (style_module_default()).disclosure_button,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (style_module_default()).disclosure_head,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "SME (Small Medium Enterprise)"
                                                        }),
                                                        !open && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (style_module_default()).toggle_btn_img,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                    src: "/assets/icon-svg/arr-down-blue.svg",
                                                                    width: 25,
                                                                    height: 25,
                                                                    layout: "fixed"
                                                                })
                                                            })
                                                        }),
                                                        open && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                                src: "/assets/icon-svg/arr-up-blue.svg",
                                                                width: 25,
                                                                height: 25,
                                                                layout: "fixed"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                                                show: open,
                                                enter: "transition duration-100 ease-out",
                                                enterFrom: "transform scaleY-95 opacity-0",
                                                enterTo: "transform scaleY-100 opacity-100",
                                                leave: "transition duration-75 ease-out",
                                                leaveFrom: "transform scaleY-100 opacity-100",
                                                leaveTo: "transform scaleY-95 opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure_esm/* Disclosure.Panel */.p.Panel, {
                                                    className: (style_module_default()).disclosure_panel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (style_module_default()).sme_description,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "รูปแบบธุรกิจในโลกปัจจุบันมีการเปลี่ยนแปลงไป ผู้คนสนใจทำธุรกิจส่วนตัวกันมากขึ้น และที่เป็นที่นิยมมากที่สุดคือ ธุรกิจขนาดย่อม หรือขนาดกลาง (SME) ตามกำลังของผู้ประกอบการ โดยใช้เงินลงทุนจำนวนไม่สูงและสามารถเป็นเจ้านายตัวเองได้คนรุ่นใหม่นิยมทำธุรกิจ SME เพราะให้ความสบายใจและไม่กดดันในการทำงาน แน่นอนว่าการเริ่มต้นทำธุรกิจ SME ต้องมีการเตรียมพร้อมสิ่งกับต่าง ๆ หลายอย่าง เช่น เรื่องงบประมาณค่าใช้จ่าย การเรียนรู้การตลาดของธุรกิจที่กำลังลงมือทำและสิ่งที่สำคัญที่ไม่ควรมองข้ามอีกประการ คือการทำประกันสำหรับธุรกิจ SME"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "การทำประกันภัยถือเป็นการลดภาระค่าใช้จ่ายในหลายมิติ เช่น ในกรณีที่สถานประกอบการเกิดเหตุเพลิงไหม้ หรือ น้ำท่วม นอกจากค่าใช้จ่ายในการซ่อมแซมตัวอาคารและปรับปรุงภายในอาคารแล้วในระหว่างที่กำลังซ่อมแซมทรัพย์สินนั้น ผู้ประกอบการอาจจะไม่สามารถดำเนินธุรกิจได้เป็นระยะเวลาหนึ่ง ซึ่งจะทำให้ขาดรายได้จากการที่ไม่สามารถดำเนินธุรกิจตามปกติได้กรมธรรม์ประกันภัยถือเป็นอีกหนึ่งเครื่องมือในการบริหารจัดการความเสี่ยงในการประกอบธุรกิจ ดังนั้นความรู้ความเข้าใจเกี่ยวกับความคุ้มครอง เงื่อนไขและข้อยกเว้นตามกรมธรรม์ประกันภัยของผู้ประกอบการ จึงเป็นสิ่งสำคัญ เนื่องจากสัญญาประกันภัยให้ความคุ้มครองที่แตกต่างหลากหลาย"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "ผู้ประกอบการควรเข้าใจความเสี่ยงภัยที่ท่านกำลังเผชิญเข้าใจเงื่อนไขและข้อยกเว้นในกรมธรรม์ก่อนตัดสินใจเลือกซื้อ อย่างไรก็ตามเพื่อเป็นทางเลือกให้แก่ผู้ประกอบการท่านสามารถเลือกใช้บริการจากที่ปรึกษาด้านการประกันภัยผู้มีความเชี่ยวชาญเฉพาะ อย่าง TQM Insurance Broker เพื่อดูแลเรื่องการประกันภัยให้ท่านอย่างมืออาชีพ"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: "เกณฑ์ในการพิจารณารับประกันภัยสำหรับธุรกิจ SME แยกตามขนาดของสินทรัพย์ ตั้งแต่มูลค่า 2 ล้านบาท - 50 ล้านบาท"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (style_module_default()).sme_coverage_details,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (style_module_default()).title,
                                        children: "ทำไมต้องเลือกความคุ้มครองประกันภัยธุรกิจ SME ผ่าน TQM Home"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "บริษัทฯ จัดหาความคุ้มครองที่เหมาะสมให้แก่ธุรกิจ SME โดยสรุปมีดังต่อไปนี้"
                                    }),
                                    content_data/* smeReasons.map */.r7.map(function(reason, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: (style_module_default()).sme_coverage_details_item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (style_module_default()).coverage_picture,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        src: reason.image,
                                                        height: "120",
                                                        width: "120",
                                                        objectFit: "contain",
                                                        layout: "responsive"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: reason.title
                                                })
                                            ]
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "".concat((style_module_default()).sme_button_container, " ").concat(isVisibleCTA ? "hidden-sticky" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, {
                            color: "blue",
                            text: "สนใจทำประกัน",
                            onClick: onClickHandler
                        })
                    })
                ]
            })
        ]
    }));
}
function Page(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Smes, _objectSpread({}, props)));
};


/***/ }),

/***/ 99733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"style_sr-only__vQKgj","!static":"style___static__IZzG0","static":"style_static__LzFdI","fixed":"style_fixed__nCJKu","absolute":"style_absolute__vs_k7","relative":"style_relative__OPraX","right-4":"style_right-4__e5yD3","top-6":"style_top-6__ERLDO","z-40":"style_z-40__snRbA","z-0":"style_z-0__5hso3","m-auto":"style_m-auto__GZElY","my-1":"style_my-1___378E","mt-4":"style_mt-4__qyTvh","mt-0":"style_mt-0__swYM0","mt-16":"style_mt-16__nXoOk","block":"style_block__37moK","inline-block":"style_inline-block__8KjCC","inline":"style_inline__NbIeu","flex":"style_flex___eCT4","table":"style_table__pkgbP","contents":"style_contents__65Zm6","hidden":"style_hidden___AC_t","h-screen":"style_h-screen__RoXjd","h-6":"style_h-6__JEKvF","min-h-[400px]":"style_min-h-__400px____YsWUL","min-h-screen":"style_min-h-screen__tiWT1","w-full":"style_w-full__MJ0h3","w-6":"style_w-6__bw2u3","origin-top":"style_origin-top__cfLMQ","-translate-y-1":"style_-translate-y-1__OIqar","translate-y-0":"style_translate-y-0__fLt7l","scale-95":"style_scale-95__DF9sj","scale-100":"style_scale-100__HE95J","scale-y-95":"style_scale-y-95__grZtt","scale-y-100":"style_scale-y-100__V1uvT","transform":"style_transform__jD5Ra","resize":"style_resize__pI3s3","items-center":"style_items-center__uxaUD","justify-between":"style_justify-between__V6Lld","gap-2":"style_gap-2__urC0f","rounded":"style_rounded__YAFSf","rounded-t-xl":"style_rounded-t-xl__Z6BUs","bg-white":"style_bg-white__1eBTb","bg-gradient-to-b":"style_bg-gradient-to-b__yk8LI","from-[#fff]":"style_from-____fff____GbYS0","to-[#E6E6E6]":"style_to-____E6E6E6____94fbg","p-3":"style_p-3__i4i6o","p-1":"style_p-1__MQTlE","p-4":"style_p-4__9_AFu","px-4":"style_px-4___HO8_","py-6":"style_py-6__S3ZRy","pb-4":"style_pb-4__z7rov","pr-7":"style_pr-7__qymL8","pb-[216px]":"style_pb-__216px____CUo9p","text-center":"style_text-center__tHy8R","text-right":"style_text-right__Y_XWa","align-top":"style_align-top__Fq___","align-middle":"style_align-middle__Eb_2k","text-xs":"style_text-xs__3AJ7_","text-lg":"style_text-lg___wd6F","text-input2":"style_text-input2__caF37","text-headline7":"style_text-headline7__hmADE","text-button-small":"style_text-button-small__PkBWm","font-bold":"style_font-bold__ilzB1","font-semibold":"style_font-semibold__FnU1K","text-tqm-red-primary":"style_text-tqm-red-primary__4vc4Q","text-white":"style_text-white__r1Elg","text-[#02A989]":"style_text-____02A989____ZBjTt","text-black":"style_text-black__06qP5","text-gray-900":"style_text-gray-900__338Mu","!text-light-blue-500":"style___text-light-blue-500__c_HUi","underline":"style_underline__4cq_9","opacity-0":"style_opacity-0__jfShj","opacity-100":"style_opacity-100__mALkr","shadow-xs":"style_shadow-xs__CT8rB","filter":"style_filter__2WMbh","transition":"style_transition__N1UBo","transition-all":"style_transition-all__NQpae","duration-100":"style_duration-100__pkhpc","duration-75":"style_duration-75__a75Hj","duration-200":"style_duration-200__3ytiL","duration-150":"style_duration-150__padVw","duration-300":"style_duration-300__q_b0Q","ease-out":"style_ease-out__dWskI","ease-in":"style_ease-in__n6ZQ4","sme_page_container":"style_sme_page_container__q_7_2","page_splash":"style_page_splash__EO1I4","page_splash_content":"style_page_splash_content__46Mk8","title_notebook":"style_title_notebook__L9FuQ","button_wrapper":"style_button_wrapper__fGOv_","title_mobile":"style_title_mobile__mCfo3","ease_items":"style_ease_items__B_css","ease_items_container":"style_ease_items_container__D_UUa","ease_item":"style_ease_item__xgKxl","ease_icon":"style_ease_icon__zbcju","sme_details":"style_sme_details__g6YRj","disclosure_button":"style_disclosure_button__6l__m","disclosure_head":"style_disclosure_head__w4nae","disclosure_panel":"style_disclosure_panel__Xgn1B","sme_coverage_details":"style_sme_coverage_details__hpPsq","title":"style_title__di_z6","sme_coverage_details_item":"style_sme_coverage_details_item__CtIvo","coverage_picture":"style_coverage_picture__bHsA9","sme_button_container":"style_sme_button_container__aVENs","tablet:block":"style_tablet__block__cFcw5","tablet:max-w-[200px]":"style_tablet__max-w-__200px____WA6Vm","tablet:p-6":"style_tablet__p-6__2F8No","tablet:text-xl":"style_tablet__text-xl__q_Pc5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(22316); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);